export default {
  common: {
    loading: 'Lädt...',
    processing: 'Verarbeitung...',
    refresh: 'Aktualisieren',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    close: 'Schließen',
    submit: 'Absenden',
    confirm: 'Bestätigen',
    yes: 'Ja',
    no: 'Nein',
    error: 'Fehler',
    success: 'Erfolg',
    warning: 'Warnung',
    info: 'Information',
    unassigned: 'Nicht zugewiesen',
    notSet: 'Nicht gesetzt',
    noDescription: 'Keine Beschreibung',
    uncategorized: 'Nicht kategorisiert',
  },
  navbar: {
    title: '🏥 zAIt Planer',
    chatSetup: 'Chat Einrichtung',
    scheduleView: 'Zeitplan Ansicht',
    constraints: 'Einschränkungen',
    profile: 'Profil',
    adminPanel: 'Admin Panel',
    logout: 'Abmelden',
  },
  login: {
    title: '🏥 zAIt Planer',
    signIn: 'Anmelden',
    createAccount: 'Konto erstellen',
    username: 'Benutzername',
    email: 'E-Mail-Adresse',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    dontHaveAccount: 'Noch kein Konto? Registrieren',
    alreadyHaveAccount: 'Bereits ein Konto? Anmelden',
    loginSuccessful: 'Anmeldung erfolgreich! Weiterleitung...',
    registrationSuccessful: 'Registrierung erfolgreich! Bitte melden Sie sich an.',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein',
    passwordTooShort: 'Passwort muss mindestens 6 Zeichen lang sein',
    unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten',
    demoAccounts: 'Demo-Konten',
    demoAdmin: 'Admin: admin / admin123',
    demoUser: 'Benutzer: user / user123',
  },
  chatConstraints: {
    title: 'Chat Einrichtung',
    description: 'Geben Sie Ihre Anforderungen ein. Mit „Speichern" werden Ihre Datenbank mit Mitarbeitern, Schichten, Tagen und Einschränkungen gefüllt. Erstellen Sie auf der Seite „Einschränkungen" Zeitpläne für bestimmte Wochen.',
    baseline: 'Basis',
    freeform: 'Freiform',
    freeformLabel: 'Beschreiben Sie Planungsanforderungen oder fügen Sie Details hinzu',
    saveAndFinalize: 'Speichern & Finalisieren',
    saveConstraintsOnly: 'Nur Einschränkungen speichern',
    clearTables: 'Tabellen löschen',
    askUpdate: 'Fragen / Aktualisieren',
    initDatabase: 'Datenbank initialisieren',
    clarificationsNeeded: 'Klarstellungen erforderlich',
    yourAnswer: 'Ihre Antwort',
    submitClarificationAnswers: 'Klarstellungsantworten absenden',
    constraintsPreview: 'Einschränkungen (Vorschau)',
    setupFinalized: 'Einrichtung erfolgreich abgeschlossen!',
    setupFinalizedMessage: 'Mitarbeiter, Schichten und Einschränkungen wurden in der Datenbank gespeichert. Verwenden Sie die Einschränkungen-Seite, um Zeitpläne für bestimmte Wochen zu generieren.',
    employees: 'Mitarbeiter',
    shifts: 'Schichten',
    constraints: 'Einschränkungen',
    clearedTables: 'Tabellen gelöscht. Zusammenfassung:',
    history: 'Verlauf (letzte 3 Runden)',
    mustBeLoggedIn: 'Sie müssen angemeldet sein, um auf die Chat-Einrichtung zuzugreifen. Bitte melden Sie sich zuerst an.',
    needAdminPrivileges: 'Sie benötigen Administratorrechte, um auf die Chat-Einrichtung zuzugreifen.',
  },
  scheduleView: {
    title: 'Wöchentlicher Zeitplan',
    weekStartDate: 'Wochenstartdatum (Montag)',
    noScheduleData: 'Keine Zeitplandaten verfügbar. Bitte generieren Sie zuerst einen Zeitplan.',
    daysScheduled: 'Geplante Tage',
    shiftsAvailable: 'Verfügbare Schichten',
    assignedSlots: 'Zugewiesene Slots',
    coverage: 'Abdeckung',
    pleaseLogin: 'Bitte melden Sie sich an, um den Zeitplan anzuzeigen.',
    shift: 'Schicht',
  },
  constraintsView: {
    title: 'Einschränkungen Verwaltung',
    subtitle: 'Verwalten Sie Planungseinschränkungen und deren Datumsbereiche',
    name: 'Name',
    category: 'Kategorie',
    description: 'Beschreibung',
    weight: 'Gewicht',
    dateStart: 'Startdatum',
    dateEnd: 'Enddatum',
    actions: 'Aktionen',
    editDates: 'Daten bearbeiten',
    totalConstraints: 'Gesamte Einschränkungen',
    withDateRange: 'Mit Datumsbereich',
    withoutDates: 'Ohne Daten',
    dateCoverage: 'Datumsabdeckung',
    noConstraintsFound: 'Keine Einschränkungen gefunden. Bitte fügen Sie zuerst einige Einschränkungen hinzu.',
    pleaseLogin: 'Bitte melden Sie sich an, um Einschränkungen anzuzeigen.',
    generateScheduleForWeek: 'Zeitplan für Woche generieren',
    generateScheduleDescription: 'Wählen Sie eine Woche (Montag), um einen Zeitplan mit aktiven Einschränkungen für diesen Zeitraum zu generieren',
    generating: 'Generierung...',
    generateSchedule: 'Zeitplan generieren',
    editDateRange: 'Datumsbereich bearbeiten für',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    saveDates: 'Daten speichern',
    pleaseSelectWeek: 'Bitte wählen Sie ein Wochenstartdatum',
    scheduleGenerated: 'Zeitplan für {weekRange} generiert! Überprüfen Sie die Zeitplan-Seite.',
    failedToGenerate: 'Zeitplan konnte nicht generiert werden',
    failedToLoad: 'Einschränkungen konnten nicht geladen werden',
    failedToUpdate: 'Einschränkungsdaten konnten nicht aktualisiert werden',
    weekStartDate: 'Wochenstartdatum (Montag)',
  },
  errors: {
    loginFailed: 'Anmeldung fehlgeschlagen',
    registrationFailed: 'Registrierung fehlgeschlagen',
    loadFailed: 'Daten konnten nicht geladen werden',
    saveFailed: 'Daten konnten nicht gespeichert werden',
    deleteFailed: 'Löschen fehlgeschlagen',
    updateFailed: 'Aktualisierung fehlgeschlagen',
    networkError: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.',
    unauthorized: 'Nicht autorisiert. Bitte melden Sie sich an.',
    forbidden: 'Verboten. Sie haben keine Berechtigung.',
    notFound: 'Ressource nicht gefunden',
    serverError: 'Serverfehler. Bitte versuchen Sie es später erneut.',
  },
  success: {
    saved: 'Erfolgreich gespeichert',
    deleted: 'Erfolgreich gelöscht',
    updated: 'Erfolgreich aktualisiert',
    created: 'Erfolgreich erstellt',
  },
};

